import { lazy } from 'react';

export const PlayerRemoveDepositLimitForm = lazy(
  () => import('./PlayerRemoveDepositLimitForm'),
);
